import { Box, useTheme } from "@mui/material";
import toHtmlColor from "@utils/toHtmlColor";
import { observer } from "mobx-react";

export interface ColorPickerSwatchProps {
  color?: string;
  onOpen?: () => void;
}

const ColorPickerSwatch = observer((props: ColorPickerSwatchProps) => {
  //console.log("ColorPickerSwatch", props);
  const theme = useTheme();

  const handleOpen = (_event: any) => {
    if (props.onOpen) {
      props.onOpen();
    }
  };

  const htmlColor = toHtmlColor(Number(props.color));
  //console.log("htmlColor: ", htmlColor);

  return (
    <Box
      sx={{
        position: "relative",
        width: "28px",
        height: "28px",
        cursor: "pointer",
        borderRadius: "8px",
        boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
        backgroundColor: htmlColor,
        border: 1,
        borderWidth: "3px",
        borderColor: theme.palette.background.default,
      }}
      onClick={handleOpen}
    ></Box>
  );
});

export default ColorPickerSwatch;
